export enum DecisionsOnPackages {
  Paket1 = 1,
  Paket2 = 2,
  Tillaggspaket = 3,
  AnnanInsats = 4,
  Paket22 = 5,
  TwelveMonths = 1001,
  TwoMonths = 1002,
  TwoMonthsDistans = 1004,
  TenMonthsDistans = 1005,
  TenMonths = 1003,
  HealthTalk = 1100,
  NeedsAnalysis = 1110,
  TeambasedMapping = 1121,
  PsychologistSupport = 1142,
  HealthAdaptedOneToFour = 1163,
  HealthAdaptedFiveToEight = 1164,
  HealthAdaptedNineToTwelve = 1165,
  GuidanceCall = 1200,
}

export const DecisionsOnPackagesTexts: {
  [key in DecisionsOnPackages]: string;
} = {
  [DecisionsOnPackages.Paket1]: '12 månader',
  [DecisionsOnPackages.Paket2]: '2 månader',
  [DecisionsOnPackages.Tillaggspaket]: 'Tilläggspaket',
  [DecisionsOnPackages.AnnanInsats]: 'Annan insats',
  [DecisionsOnPackages.Paket22]: 'Paket 22',
  [DecisionsOnPackages.TwelveMonths]: '12 mån stöd på plats',
  [DecisionsOnPackages.TwoMonths]: '2 mån stöd på plats',
  [DecisionsOnPackages.TwoMonthsDistans]: '2 mån stöd digitalt',
  [DecisionsOnPackages.TenMonthsDistans]: '10 månader stöd digitalt',
  [DecisionsOnPackages.TenMonths]: '10 månader stöd på plats',
  [DecisionsOnPackages.HealthTalk]: 'Hälsosamtal',
  [DecisionsOnPackages.NeedsAnalysis]: 'Behovsanalys',
  [DecisionsOnPackages.TeambasedMapping]: 'Teambaserad kartläggning',
  [DecisionsOnPackages.PsychologistSupport]: 'Psykologstöd',
  [DecisionsOnPackages.GuidanceCall]: 'Vägledningssamtal',
  [DecisionsOnPackages.HealthAdaptedOneToFour]: 'Hälsoanpassat stöd 1-4 mån',
  [DecisionsOnPackages.HealthAdaptedFiveToEight]: 'Hälsoanpassat stöd 5-8 mån',
  [DecisionsOnPackages.HealthAdaptedNineToTwelve]:
    'Hälsoanpassat stöd 9-12 mån',
};
